import css from './SymptomList.module.css';
import { H3, Paragraph, StackedColumn, StackedColumnSpacing } from '../../../../../../../core';

interface SymptomListProps {
  header: string;
  symptomList: string[];
}

const SymptomList: React.FC<SymptomListProps> = (props: SymptomListProps) => {
  return (
    <StackedColumn spacing={StackedColumnSpacing.Tight}>
      <H3 className={css.symptomHeader} text={props.header} />
      <ul className={css.symptomList}>
        {props.symptomList.map((symptom, index) => (
          <li key={index}>
            <Paragraph text={symptom} />
          </li>
        ))}
      </ul>
    </StackedColumn>
  );
};

export default SymptomList;
